import { gql, TypedDocumentNode } from '@apollo/client';

import {
  SearchCategoriesConnection,
  SearchCategoriesConnectionInput,
} from '@atom/types/category';

export const SEARCH_CATEGORIES: TypedDocumentNode<
  { categoriesSearch: SearchCategoriesConnection },
  { input: SearchCategoriesConnectionInput }
> = gql`
  query categoriesSearch($input: SearchCategoriesConnectionInput!) {
    categoriesSearch(input: $input) {
      totalCount
      categories {
        id
        name
        schemaId
        colorId
        categoryPath {
          id
          name
        }
      }
    }
  }
`;
